import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.css';

const STORAGE_KEY = 'concierge_banner_dismissed';

const isJuly2026 = () => {
  const now = new Date();
  return now.getFullYear() === 2026 && now.getMonth() === 6; // 0-indexed, 6 = July
};

const ConciergeBanner = () => {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(STORAGE_KEY) === 'true');

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setDismissed(true);
  };

  if (dismissed) return null;

  return (
    <div className="concierge-banner">
      <div className="concierge-banner__left">
        <img
          className="concierge-banner__icon"
          src="https://dashboard-v2-images.s3.amazonaws.com/concierge-promo.png"
          alt="Concierge"
        />
        <div className="concierge-banner__text">
          <span className="concierge-banner__title">Introducing Concierge</span>
          <span className="concierge-banner__desc">
            Let us run your events! We send texts, handle replies, and book appointments. No lift for your team.
          </span>
          {isJuly2026() && <span className="concierge-banner__highlight">25% OFF IN JULY</span>}
        </div>
      </div>
      <div className="concierge-banner__right">
        <a
          className="concierge-banner__learn-more"
          href="https://www.clientbookconcierge.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          LEARN MORE
        </a>
        <button
          type="button"
          className="concierge-banner__close"
          onClick={handleDismiss}
          aria-label="Dismiss banner"
        >
          <FontAwesomeIcon icon={['far', 'times']} />
        </button>
      </div>
    </div>
  );
};

export default ConciergeBanner;
